import * as React from 'react';
import {Link} from 'react-router-dom';
import {paths} from './../../../config/paths';
import {Field} from 'redux-form';
import {Button} from 'semantic-ui-react';
import {Input} from '@/migration/input';
import {enhance} from './enhancer';
import {setState} from './state';
import {handlers} from './handlers';

import './index.scss';

function Main(props: any) {
  const {handleSubmit} = props;
  const state = setState();

  return (
    <div className="a__reset_password">
      <div className="bf__form">
        <div className="b__title c__before-title">
          <h1>パスワードリセット</h1>
        </div>
        <div className="b__messages">
          メールアドレス宛にパスワードリセットの為の認証コードを送信します。
          <br />
          メールアドレスを入力してください。
          <br />
          パスワードリセットの必要が無ければ&nbsp;
          <Link to={paths.signIn.main}>サインイン</Link>
          &nbsp;してください。
        </div>
        <form
          className="b__form"
          onSubmit={handleSubmit(async (values: any) => {
            await handlers.resetPassword(props, state, values);
          })}
        >
          <Field
            name="email"
            component={Input}
            type="text"
            placeholder="メールアドレス"
            fluid
            outline
            disabled={state.loading || props.submitting}
          />
          <div className="w__actions">
            <Button
              positive
              fluid
              type="submit"
              disabled={state.loading || props.submitting}
              loading={state.loading || props.submitting}
            >
              メールを送信する
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default enhance((props: any) => <Main {...props} />);
